import Component from '../core/Component'

export default class SearchOpener extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const searchLayer = Component.getFromElement('search-layer')

        if (searchLayer) {
            event.preventDefault()
            searchLayer.toggle()
        }
    }

}